import { render, staticRenderFns } from "./DropDownText.vue?vue&type=template&id=2ff1ed98&"
import script from "./DropDownText.vue?vue&type=script&lang=ts&"
export * from "./DropDownText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports